// silent-refresh.service.ts
import { Injectable } from '@angular/core';
import { startSilentRefreshToken } from '@grupovanti/silent-refresh';

@Injectable({ providedIn: 'root' })
export class SilentRefreshService {
  start(config: any) {
    startSilentRefreshToken(config);
  }
}
